import React from 'react';
import { formatNumber, formatMoney } from '../../utils/marketFormatters';

/**
 * Market page hero — title/subtitle + optional header stat strip.
 * Stats are omitted (not shown as 0) if the underlying KPI is unavailable.
 */
export const MarketHeader = ({ kpis, generatedAt, loading }) => {
  const stats = [
    { label: 'Active Showdowns', value: kpis?.activeShowdowns },
    { label: 'Runners Tracked', value: kpis?.runnersTracked != null ? formatNumber(kpis.runnersTracked) : null },
    { label: 'Virtual Prizemoney Analysed', value: kpis?.virtualPrizemoneyAnalysed != null ? formatMoney(kpis.virtualPrizemoneyAnalysed) : null },
  ].filter(s => s.value != null && s.value !== '—');

  return (
    <div className="mk-header">
      <div className="mk-header-main">
        <h1 className="mk-title">
          <span className="mk-title-icon" aria-hidden="true">📈</span> Market
        </h1>
        <p className="mk-subtitle">
          Track runner value, ownership trends, ratings performance and stable-building opportunities.
        </p>
      </div>

      {!loading && stats.length > 0 && (
        <div className="mk-header-stats">
          {stats.map(s => (
            <div className="mk-header-stat" key={s.label}>
              <span className="mk-header-stat-value">{s.value}</span>
              <span className="mk-header-stat-label">{s.label}</span>
            </div>
          ))}
        </div>
      )}

      {generatedAt && !loading && (
        <div className="mk-generated-at">
          Updated {new Date(generatedAt).toLocaleTimeString('en-AU', { hour: '2-digit', minute: '2-digit' })}
        </div>
      )}
    </div>
  );
};

export default MarketHeader;
